import { takeLatest, put } from "redux-saga/effects";
import { FETCH_DOCUMENTATION_REQUEST, REDIRECT_TO_LOGIN } from "./actionsTypes";
import {
  fetchDocumentationSuccess,
  fetchDocumentationFailure,
  redirectToLogin,
} from "./actions";
import Config from "config";
import axios from "axios";
function* fetchDocumentation(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_documentation_reglementaire`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchDocumentationSuccess(response.data));
  } catch (error) {
    // yield put(fetchSyntheseFailure(error));
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* documentationSaga() {
  yield takeLatest(FETCH_DOCUMENTATION_REQUEST, fetchDocumentation);
}

export default documentationSaga;
